import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Checkbox, { CheckboxProps } from './Checkbox';

const FilterListItem = styled<any, any>('li')`
    ${propStyles};
`;

const checkboxStyleProps = {
    CheckboxChecked: {
        height: "1.4em",
        width: "1.4em",
        marginX: "xs"
    },
    CheckboxUnchecked: {
        height: "1.4em",
        width: "1.4em",
        marginX: "xs"
    }
};

interface FilterValueProps extends CheckboxProps {
}

const FilterValue: React.SFC<FilterValueProps> = ({ theme, label, checked, onChange, active, ...props }) => (
    <FilterListItem
        {...props}
    >
        <Checkbox
            label={label}
            checked={checked}
            active={active}
            onChange={onChange}
            theme={{
                ...theme,
                ...checkboxStyleProps
            }}
        />
    </FilterListItem>
);

export default withTheme(observer(FilterValue));


// WEBPACK FOOTER //
// ./src/Components/FilterValue.tsx